// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import * as React from 'react';
import svg, { path } from 'react-native-svg';
function DrugIcon16(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.51 12.44c-1.09-.667-1.953-.5-3.796-1.667a.335.335 0 0 0-.46.107.333.333 0 0 0 .103.453c1.907 1.197 2.834 1.08 3.81 1.667a.333.333 0 0 0 .334-.57l.01.01Z"
      />
      <path
        fill="currentColor"
        d="M27.453 6.51h-3a3.419 3.419 0 0 0-2.666-4.46c-.034-.017.536.09-6.304-1.09C14.15.733 13.816 0 12.586 0c-1.23 0-2.29.847-2.29 1.887 0 1.38 1.737 2.273 3.22 1.72a2.97 2.97 0 0 1 1.547-.184l6.303 1.087a.933.933 0 0 1 .147 1.8l-.487.2H4.546a.333.333 0 0 0-.31.457 12.687 12.687 0 0 0 4.92 6 4.42 4.42 0 0 0 2.667 5.666l2.437.874.18 4.23-.563.113a3.333 3.333 0 0 0-2.484 4.433 7.09 7.09 0 0 0-3.06 3.25.333.333 0 0 0 .3.467h14.733a.334.334 0 0 0 .3-.467c-1-2.283-3.373-3.926-6.26-4.333l.07-1.533 1.71-.334a3.47 3.47 0 0 0 2.737-2.56 3.39 3.39 0 0 0-2.15-3.96c-.033 0 .284.104-1.973-.703l.073-1.667a2.053 2.053 0 0 1 1.48-1.913 12.668 12.668 0 0 0 8.41-7.563.333.333 0 0 0-.31-.457ZM21.48 3.843l-6.293-1.076A3.613 3.613 0 0 0 13.293 3c-1.063.397-2.333-.203-2.333-1.097 0-1 1.54-1.58 2.593-.97a5.404 5.404 0 0 0 1.813.7l6.3 1.074A2.763 2.763 0 0 1 23.74 6.51h-1.367a1.59 1.59 0 0 0-.893-2.657v-.01Zm-6.894 23.334a9.552 9.552 0 0 0-.87.173.844.844 0 0 1 .64-1.077l.19-.04.04.944Zm-2.9 1.666c.274.453.652.833 1.104 1.107l2.243 1.383H9.17a6.583 6.583 0 0 1 2.517-2.466v-.024Zm4.647 2.49-3.2-1.93A2.667 2.667 0 0 1 14 24.49l.463-.093.05 1.176-.29.057A1.523 1.523 0 0 0 13 27.117a1.54 1.54 0 0 0 .73 1.293l4.837 2.923h-2.234Zm6.5 0h-2.98l-5.62-3.403a5.587 5.587 0 0 1 1.56-.113.333.333 0 0 0 0-.667h-.54c-.793-18.483.537 12.517-.32-7.413l2.1.75c-.073 1.666.17-3.974-.3 6.983a.334.334 0 0 0 .297.333c2.58.3 4.753 1.63 5.803 3.53Zm-3.903-10.17a.88.88 0 0 1-.127 1.694l-1.213.24.1-2.377 1.24.443Zm2.333 1.457a2.806 2.806 0 0 1-2.207 2.047l-1.55.333.054-1.2 1.373-.27a1.55 1.55 0 0 0 .22-2.977L12.047 18a3.76 3.76 0 0 1-2.314-4.693c.184.103.667.36 1.06.54a2.59 2.59 0 0 0 1.647 3.05l7.107 2.543a2.714 2.714 0 0 1 1.726 3.18h-.01Zm-8.617-8.107a2.047 2.047 0 0 1 1.48 1.914v.37l-1.46-.53a1.92 1.92 0 0 1-1.243-2.164c.4.16.809.296 1.223.41Zm6.53-.64a2.717 2.717 0 0 0-1.97 2.527l-.063 1.47-2.333-.83-.027-.64a2.703 2.703 0 0 0-1.973-2.527 12.034 12.034 0 0 1-7.763-6.696h21.906a12.03 12.03 0 0 1-7.776 6.696Z"
      />
    </svg>
  );
}
export default DrugIcon16;
